var parent = require('../../es/object/create');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/object/create.js
// module id = 472
// module chunks = 0 1